import React from "react";

import SkipLink from "./components/SkipLink";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TrustBar from "./components/TrustBar";
import Services from "./components/Services";
import Process from "./components/Process";
import Stats from "./components/Stats";
import Portfolio from "./components/Portfolio";
import Testimonials from "./components/Testimonials";
import Team from "./components/Team";
import Contact from "./components/Contact";
import LegalSection from "./components/LegalSection";
import Footer from "./components/Footer";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";

function App() {
  return (
    <div className="app">
      <SkipLink />
      <Navbar />

      <main id="main-content">
        <Hero />

        <TrustBar />

        <Services />

        <Process />

        <Stats />

        <Portfolio />

        <Testimonials />

        <Team />

        <Contact />

        <LegalSection />
      </main>

      <Footer />

      <Analytics />
      <SpeedInsights />
    </div>
  );
}

export default App;
